import { render, staticRenderFns } from "./EditarRemesaDialogComponent.vue?vue&type=template&id=212f8b14"
import script from "./EditarRemesaDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarRemesaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports